import React from "react";
import "./payment.css";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/GlobalState";
import { CheckOurCard } from "../checkoutcard/CheckOurCard";
import CurrencyFormat from "react-currency-format";
import { CardElement } from "@stripe/react-stripe-js";
export const Payment = () => {
  const { basket, user } = useAuth();
  console.log(basket);
  const getBasketTotal = (basket) => {
    return basket.reduce((a, b) => {
      return a + b.price;
    }, 0);
  };
  const handleChange = () => {};
  const handleSubmit = (ev) => {
    ev.preventDefault();
  };
  return (
    <div className="payment">
      <h1>
        checkout (<Link to="/chheckout">{basket.length} items</Link>)
      </h1>
      <div className="payment-container">
        <div className="payment-content">
          <div className="payment-title">
            <h3>Delivery Address</h3>
            <div className="addressValue">
              <p>{user?.email}</p>
              <p>benha,egypt</p>
            </div>
          </div>
          <hr />
          <div className="payment-products">
            <h3>Delivery products</h3>
            <div>
              {basket.map((el, idx) => {
                return (
                  <CheckOurCard
                    key={idx}
                    id={el.id}
                    title={el.title}
                    img={el.img}
                    rate={el.rate}
                    price={el.price}
                  />
                );
              })}
            </div>
          </div>
          <hr />
          <div className="payment-method">
            <h3>Payment Method</h3>
            <div className="method-content">
              <form className="pay-info" onSubmit={handleSubmit}>
                {/* <div className="top">
                  <input required type="text" placeholder="credit card" />
                  <input required type="text" placeholder="cvc" />
                  <input required type="text" placeholder="password" />
                  <input required type="text" placeholder="cvc" />
                </div> */}
                <CardElement onChange={handleChange} />
                <CurrencyFormat
                  decimalScale={2}
                  value={getBasketTotal(basket)}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                  renderText={(value) => (
                    <h3 className="total">
                      Order Total: <strong>{value}</strong>
                    </h3>
                  )}
                />
                <button>Buy Now</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
